<template>
    <common-modal v-if="isOpen" width="extra-large" @close="emitEvent({ name: 'close' })">
        <common-page-header :heading="$t('forms.addpatient.heading')" :isCenter="true" size="minor"></common-page-header>
        <common-content-spacer height="medium" class="add-patient-form">
            <add-patient-form @cancel="emitEvent({ name: 'close' })"></add-patient-form>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import AddPatientForm from 'components/forms/patient/AddPatientForm'
    export default {
        components: { AddPatientForm },
        props: {
            isOpen: { type: Boolean, required: true },
        },
    }
</script>

<style scoped>
    .add-patient-form {
        margin-top: 30px;
    }
</style>
